<template>
  <div>
    
    <v-tour name="myTour" :steps="steps" :options="myOptions">
    </v-tour>
  </div>
</template>

<script>

import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();
  export default {
    name: 'my-tour',
    data () {
      return {
        steps: [
          {
				target: '.page-title-h2',
				header: {
					title: '<div><i class="fa fa-check-circle color-white fa-3x pt-3 icon-size"></i></div><div><b class="font-14">وظایف و کارهای من</b></div>',
				},
             content: 'در این صفحه می توانید کارهای مرتبط با خود یا سایر کاربران را ثبت و زمابندی کنید.',
               
          },
          {
            target: '#addBtn',
            content: `با زدن این دکمه می توانید وظیفه جدید ثبت کنید.`,
            
          },
          {
            target: '#filterBtn',
            content: 'در اینجا می توانید لیست وظایف را بر اساس کاربران و وضعیت وظیفه فیلتر کنید.',
            params: {
              highlight:true,
              enableScrolling: false
            }
          },
          
        ],
         myOptions: {
          useKeyboardNavigation: false,
           enableScrolling: false,
          labels: {
            buttonSkip: 'فهمیدم!',
            buttonPrevious: 'قبلی',
            buttonNext: 'بعدی',
            buttonStop: 'اتمام'
        }
        },
        
      }
     
    },
    mounted: function () {
      var _this=this;
      var passtask=cookies.get('passtask');
      if(passtask!=1)
      {
         setTimeout(function(){
      _this.$tours['myTour'].start();
      var c=cookies.set("passtask",1,"1000d");
      console.log(c);
      },3000)

      }
     
    }
  }
</script>
<style>
.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0,0,0,.4);
}
	.v-step[data-v-c1b3a65a] {
		border-radius: 10px !important;
		background: linear-gradient(to bottom, #AC92EC 0, #6A50A7 100%) !important;
	}
	.v-step[x-placement^=bottom] .v-step__arrow[data-v-c1b3a65a] {
		border-left-color: transparent !important;
		border-right-color: transparent !important;
		border-top-color: transparent !important;
	}
	.v-step[x-placement^=top] .v-step__arrow[data-v-c1b3a65a] {
		border-left-color: transparent !important;
		border-right-color: transparent !important;
		border-bottom-color: transparent !important;
	}
	.v-step .v-step__arrow[data-v-c1b3a65a] {
		border-color: #967ADC !important;
	}
	.v-step__button[data-v-c1b3a65a] {
		border-radius: 5px !important;
	}
	.v-step__header[data-v-c1b3a65a] {
		background-color: transparent !important;
		border-top-left-radius: 10px !important;
		border-top-right-radius: 10px !important;
	}
</style>